import type { DocCollection } from '@blocksuite/store';
import { toast } from '@pique/component';
import { useI18n } from '@pique/i18n';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { trashModalAtom } from '../../atoms/trash-modal';
import { useBlockSuiteMetaHelper } from './use-block-suite-meta-helper';

export function useTrashModalHelper(docCollection: DocCollection) {
  const t = useI18n();
  const [trashModal, setTrashModal] = useAtom(trashModalAtom);
  const { pageIds } = trashModal;
  const { removeToTrash } = useBlockSuiteMetaHelper(docCollection);

  const handleOnConfirm = useCallback(() => {
    pageIds.forEach(pageId => {
      removeToTrash(pageId);
    });
    toast(t['com.pique.toastMessage.movedTrash']());
    setTrashModal({ ...trashModal, open: false });
  }, [pageIds, removeToTrash, setTrashModal, t, trashModal]);

  return {
    trashModal,
    setTrashModal,
    handleOnConfirm,
  };
}
